// extracted by mini-css-extract-plugin
export var card = "_8i-1";
export var container = "_8i-0";